import CampaignBanner from "../../../../../../../../assets/images/campaign-banner.png";
import DatatableComponent from "../../../../../../../../components/common/DatatableComponent/DatatableComponent";

const Closed = () => {
  const data = [
    {
      campaignName: "7-7 Sale",
      campaignBanner: CampaignBanner,
      campaignStartDate: "07/07/2024",
      campaignEndDate: "17/07/2024",
      regestrationClosingDate: "06/07/2024",
      status: "Upcoming",
    },
    {
      campaignName: "7-7 Sale",
      campaignBanner: CampaignBanner,
      campaignStartDate: "07/07/2024",
      campaignEndDate: "17/07/2024",
      regestrationClosingDate: "06/07/2024",
      status: "Upcoming",
    },
    {
      campaignName: "7-7 Sale",
      campaignBanner: CampaignBanner,
      campaignStartDate: "07/07/2024",
      campaignEndDate: "17/07/2024",
      regestrationClosingDate: "06/07/2024",
      status: "Upcoming",
    },
    {
      campaignName: "7-7 Sale",
      campaignBanner: CampaignBanner,
      campaignStartDate: "07/07/2024",
      campaignEndDate: "17/07/2024",
      regestrationClosingDate: "06/07/2024",
      status: "Upcoming",
    },
    {
      campaignName: "7-7 Sale",
      campaignBanner: CampaignBanner,
      campaignStartDate: "07/07/2024",
      campaignEndDate: "17/07/2024",
      regestrationClosingDate: "06/07/2024",
      status: "Upcoming",
    },
    {
      campaignName: "7-7 Sale",
      campaignBanner: CampaignBanner,
      campaignStartDate: "07/07/2024",
      campaignEndDate: "17/07/2024",
      regestrationClosingDate: "06/07/2024",
      status: "Upcoming",
    },
    {
      campaignName: "7-7 Sale",
      campaignBanner: CampaignBanner,
      campaignStartDate: "07/07/2024",
      campaignEndDate: "17/07/2024",
      regestrationClosingDate: "06/07/2024",
      status: "Upcoming",
    },
    {
      campaignName: "7-7 Sale",
      campaignBanner: CampaignBanner,
      campaignStartDate: "07/07/2024",
      campaignEndDate: "17/07/2024",
      regestrationClosingDate: "06/07/2024",
      status: "Upcoming",
    },
  ];

  const columns = [
    {
      name: "Campaign name",
      selector: (row) => row.campaignName,
      minWidth: "160px",
    },
    {
      name: "Campaign Banner",
      cell: (row) => <img src={row.campaignBanner} />,
      minWidth: "160px",
    },
    {
      name: "Campaign Start Date",
      selector: (row) => row.campaignStartDate,
      minWidth: "180px",
    },
    {
      name: "Campaign End Date",
      selector: (row) => row.campaignEndDate,
      minWidth: "180px",
    },
    {
      name: "Registration Closing Date",
      selector: (row) => row.regestrationClosingDate,
      minWidth: "220px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      minWidth: "120px",
    },
  ];

  return (
    <div className="bg-white p-2">
      <DatatableComponent
        data={data}
        columns={columns}
        type={"gray-bordered"}
      />
    </div>
  );
};

export default Closed;